<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Dashboard
        <small>it all starts here</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Dashboard</a></li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-body">
          Let's start submitting your activity or tour packages
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'DashboardIndex',
  };
</script>



// WEBPACK FOOTER //
// src/components/modules/dashboard/Index.vue